module.exports = __webpack_public_path__ + "static/media/puzzle-16-bg.41ac387b.svg";